import { render, staticRenderFns } from "./gce-pd.vue?vue&type=template&id=2b236497&"
import script from "./gce-pd.vue?vue&type=script&lang=js&"
export * from "./gce-pd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports